<template>
  <v-app-bar
    app
    color="white"
    flat
    :elevation="1"
    :shrink-on-scroll="!authReady && $vuetify.breakpoint.mdAndUp"
    style="z-index: 99"
    clipped-left
  >
    <v-app-bar-nav-icon
      v-if="$vuetify.breakpoint.mdAndDown"
      @click="layout.drawer = !layout.drawer"
    />

    <router-link
      :to="{ name: 'home', params: { lang: this.$route.params.lang } }"
      style="height: 100%; max-height: 100px;"
    >
      <img
        src="/static/logo_jobs2share.svg"
        alt="jobs2Share"
        class="logo"
        style="height: 100%; width: auto;"
      />
    </router-link>

    <v-spacer/>
    <div v-if="$vuetify.breakpoint.mdAndUp">
      <v-btn
        text
        class="mx-1"
        :to="{ name: 'job.list', params: { lang: language } }"
        v-html="'Jobs'"
      />
      <v-menu
        :close-on-content-click="true"
        offset-y
        nudge-top="-40px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            class="mx-1"
            v-bind="attrs"
            v-on="on"
          >
            {{ $t('content.howItWorksEmployer.label') }}
          </v-btn>
        </template>

        <v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-list>
                    <v-list-item :to="{ name: 'page.find-a-job', hash: '', params: { lang: this.language } }">
                      <v-list-item-action>
                        <v-icon>
                          person
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.jobFind.label') }}</v-list-item-title>
                        <v-list-item-subtitle>{{ $t('content.jobFind.forEmployees') }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'page.find-a-job', hash: '#section-1', params: { lang: this.language } }">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.howItWorksEmployee.label') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'page.find-a-job', hash: '#section-2', params: { lang: this.language } }">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.advantagesEmployee.label') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'page.employee.further-education', params: { lang: this.language } }">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.furtherEducation.label') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'page.employee.seco-pilot', params: { lang: this.language } }">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.advantagesEmployee.unemploymentBenefits') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'page.find-a-job', hash: '#section-3', params: { lang: this.language } }">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.employeesSays.label') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'page.find-a-job', hash: '#section-4', params: { lang: this.language } }">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.faqsEmployees.label') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-divider vertical/>
                <v-col>
                  <v-list>
                    <v-list-item :to="{ name: 'page.job-advertisement', hash: '', params: { lang: this.language } }">
                      <v-list-item-action>
                        <v-icon>
                          business
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.jobAdvertisement.findEmployees') }}</v-list-item-title>
                        <v-list-item-subtitle>{{ $t('content.jobAdvertisement.forEmployers') }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'page.job-advertisement', hash: '#section-1', params: { lang: this.language } }">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.howItWorksEmployer.label') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'page.job-advertisement', hash: '#section-2', params: { lang: this.language } }">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.advantagesEmployer.label') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'page.job-advertisement', hash: '#section-3', params: { lang: this.language } }">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.offerEmployers.label') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'page.job-advertisement', hash: '#section-4', params: { lang: this.language } }">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.employersSays.label') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'page.job-advertisement', hash: '#section-5', params: { lang: this.language } }">
                      <v-list-item-content>
                        <v-list-item-title>{{ $t('content.faqsEmployers.label') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-menu>
      <v-btn
        text
        class="mx-1"
        :to="{ name: 'page.careerday', params: { lang: language } }"
        v-html="'Career Day'"
      />
    </div>
    <notifications v-if="showNotifications"/>
    <v-menu offset-y v-if="!authReady">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          class="mx-1"
          outlined color="primary"
        >
          {{ getLanguageName }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="item in languageItems"
          :key="item.title"
          @click="changeLanguage(item.langKey)"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ item.langName }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <template v-if="!maintenanceActive">
      <v-btn
        outlined color="primary"
        v-if="!$auth.check()"
        class="mx-1"
        @click="showUserLoginDialog()"
      >
        {{ $t('texts.login') }}
      </v-btn>
      <v-btn
        outlined color="primary"
        v-if="$vuetify.breakpoint.mdAndUp && !$auth.check()"
        class="mx-1"
        @click="showUserRegistrationDialog()"
      >
        {{ $t("texts.register") }}
      </v-btn>
      <v-btn
        outlined color="primary"
        v-if="$auth.check() && !maintenanceActive"
        class="mx-1"
        @click="handleLogout()"
      >
        {{ $t('texts.logout') }}
      </v-btn>
      <v-btn
        v-if="authReady && authUser.is_employee === false"
        text icon color="primary"
        :to="{ name: 'user.profile' }"
      >
        <v-icon dark>settings</v-icon>
      </v-btn>
    </template>
  </v-app-bar>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Notifications from '../user/Notifications.vue';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');

export default {
  name: 'AppHeader',
  components: {
    Notifications,
  },
  props: {
    layout: {
      type: Object,
    },
    authReady: {
      type: Boolean,
    },
  },
  data() {
    return {
      languageItems: [
        { langKey: 'de', langName: 'Deutsch' },
        { langKey: 'it', langName: 'Italiano' },
        { langKey: 'en', langName: 'English' },
      ],
    };
  },
  computed: {
    ...mapUserState([
      'maintenanceActive',
      'authUser',
      'language',
    ]),
    getLanguageName() {
      const selectedLanguage = this.languageItems.find((language) => language.langKey === this.language);
      return selectedLanguage.langKey;
    },
    showNotifications() {
      if (this.$auth.check()) {
        if (this.authUser.is_employee) {
          return true;
        } if (this.$route.matched.length > 0 && this.$route.matched[0].name === 'companyIndex') {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    ...mapUserActions([
      'resetState',
      'setLanguage',
    ]),
    handleLogout() {
      localStorage.clear();
      this.$auth.logout({
        makeRequest: false,
        redirect: `/${this.$i18n.locale}`,
        success() {
          this.resetState();
          this.layout.drawer = false;
        },
      });
    },
    showUserLoginDialog() {
      this.$eventBus.$emit('show-user-login-dialog');
    },
    showUserRegistrationDialog() {
      this.$eventBus.$emit('show-user-registration-dialog');
    },
    changeLanguage(language) {
      this.setLanguage(language);
      this.$router.push({ params: { lang: language } });
      this.$i18n.locale = language;
    },
  },
};
</script>
